import React from 'react';
import { Grid, Paper, Table, TableBody, TableRow, TableCell, TableContainer, TableHead, Box, Link } from '@material-ui/core';

import { Title } from 'app/components';
import KeywordChip from './KeywordChip';

const ConnectionsTable = ({ title, rows, classes }) => {
  if (!rows?.length) return null;

  return (
    <Grid item xs={12}>
      <TableContainer component={Paper} className={classes.table}>
        <Title prefix={title} className={classes.title} />
        <Table>
          <TableHead>
            <TableRow>
              <TableHead>
                <TableRow>
                  <TableCell style={{ width: '40%' }}>
                    <strong>Name</strong>
                  </TableCell>
                  <TableCell style={{ width: '30%' }}>
                    <strong>Association</strong>
                  </TableCell>
                  <TableCell style={{ width: '30%' }}>
                    <strong>Keywords</strong>
                  </TableCell>
                </TableRow>
              </TableHead>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((p, i) => (
              <TableRow key={i} hover>
                <TableCell>
                  {p.url ? (
                    <Link href={p.url} target="_blank" rel="noopener noreferrer">
                      {p.name || p.url}
                    </Link>
                  ) : (
                    p.name || '-'
                  )}
                </TableCell>
                <TableCell>{p.associations || '-'}</TableCell>
                <TableCell>
                  <Box display="flex" flexWrap="wrap" gap={0.5}>
                    {p.keywords?.length > 0 ? p.keywords.map((kw, j) => <KeywordChip key={j} code={kw} classes={classes} />) : '-'}
                  </Box>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Grid>
  );
};

export default ConnectionsTable;
